import React, { Component } from 'react';
import { motion } from 'framer-motion';
export type CardVariant = 'elevated' | 'flat' | 'outlined';
export interface CardProps {
  variant?: CardVariant;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  children: React.ReactNode;
  animate?: boolean;
}
const variantStyles: Record<CardVariant, string> = {
  elevated: 'bg-white shadow-card border border-surface-100',
  flat: 'bg-surface-50 border border-surface-200',
  outlined: 'bg-white border border-surface-200'
};
const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
};
export function Card({
  variant = 'elevated',
  padding = 'md',
  className = '',
  children,
  animate = false
}: CardProps) {
  const Component = animate ? motion.div : 'div';
  const animationProps = animate ? {
    initial: {
      opacity: 0,
      y: 10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3
    }
  } : {};
  return <Component className={`
        rounded-card
        ${variantStyles[variant]}
        ${paddingStyles[padding]}
        ${className}
      `} {...animationProps} data-id="element-439">
      {children}
    </Component>;
}
// Card Header subcomponent
export interface CardHeaderProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
}
export function CardHeader({
  title,
  subtitle,
  action,
  className = ''
}: CardHeaderProps) {
  return <div className={`flex items-start justify-between ${className}`} data-id="element-440">
      <div data-id="element-441">
        <h3 className="text-heading-md text-surface-900" data-id="element-442">{title}</h3>
        {subtitle && <p className="text-body-sm text-surface-500 mt-0.5" data-id="element-443">{subtitle}</p>}
      </div>
      {action && <div data-id="element-444">{action}</div>}
    </div>;
}
// Card Content subcomponent
export interface CardContentProps {
  className?: string;
  children: React.ReactNode;
}
export function CardContent({
  className = '',
  children
}: CardContentProps) {
  return <div className={className} data-id="element-445">{children}</div>;
}
// Card Footer subcomponent
export interface CardFooterProps {
  className?: string;
  children: React.ReactNode;
}
export function CardFooter({
  className = '',
  children
}: CardFooterProps) {
  return <div className={`border-t border-surface-100 pt-4 mt-4 ${className}`} data-id="element-446">
      {children}
    </div>;
}